import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ToggleButton = styled(motion.button)`
  width: 60px;
  height: 32px;
  border-radius: 16px;
  background: ${props => props.isDark ? 'rgba(30, 30, 30, 0.9)' : 'rgba(255, 255, 255, 0.9)'};
  border: 2px solid ${props => props.isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'};
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  padding: 2px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px ${props => props.theme.colors.shadow};
  transition: all 0.2s ease;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  
  &:hover {
    box-shadow: 0 6px 20px ${props => props.theme.colors.shadow};
    transform: translateY(-1px);
    background: ${props => props.isDark ? 'rgba(40, 40, 40, 0.95)' : 'rgba(250, 250, 250, 0.95)'};
  }
  
  &:active {
    transform: translateY(0px) scale(0.98);
    transition: all 0.1s ease;
  }
  
  &:focus-visible {
    outline: 2px solid ${props => props.theme.colors.text};
    outline-offset: 2px;
  }
`;

const ToggleKnob = styled(motion.div)`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background: ${props => props.isDark ? '#1a1a1a' : '#ffffff'};
  border: 1px solid ${props => props.isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.15)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  box-shadow: 0 2px 8px ${props => props.isDark ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.15)'};
`;

const ThemeToggle = () => {
  const { theme, toggleTheme, themeData, isDark } = useTheme();

  const knobVariants = {
    dark: { x: 0 },
    light: { x: 28 }
  };

  const handleToggle = (e) => {
    e.stopPropagation();
    toggleTheme();
  };

  return (
    <ToggleContainer>
      <ToggleButton
        onClick={handleToggle}
        theme={themeData}
        isDark={isDark}
        title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      >
        <ToggleKnob
          theme={themeData}
          isDark={isDark}
          variants={knobVariants}
          animate={theme}
          transition={{
            type: "spring",
            duration: 0.3,
            damping: 20,
            stiffness: 300
          }}
        >
          {theme === 'dark' ? '🌙' : '☀️'}
        </ToggleKnob>
      </ToggleButton>
    </ToggleContainer>
  );
};

export default ThemeToggle;